(function () {
  if (window.PupPlanetHomeInstalled) return;
  window.PupPlanetHomeInstalled = true;

  function directionsElements() {
    return {
      modal: document.querySelector('[data-pp-directions-modal]'),
      backdrop: document.querySelector('.directions-backdrop')
    };
  }

  function setDirections(open) {
    var elements = directionsElements();
    if (!elements.modal || !elements.backdrop) return;
    elements.modal.classList.toggle('is-open', open);
    elements.backdrop.classList.toggle('is-open', open);
    elements.modal.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('pp-modal-open', open);
    if (open) {
      window.setTimeout(function () {
        var close = elements.modal.querySelector('[data-pp-directions-close]');
        if (close) close.focus();
      }, 50);
    }
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-pp-directions-open]');
    if (openButton) {
      event.preventDefault();
      setDirections(true);
      return;
    }

    var closeButton = event.target.closest('[data-pp-directions-close]');
    if (closeButton) {
      event.preventDefault();
      setDirections(false);
      return;
    }

    var mapLink = event.target.closest('[data-pp-directions-modal] a');
    if (mapLink) setDirections(false);

    var homeAnchor = event.target.closest('.menu-drawer a[href^="/#"], .menu-drawer a[href^="#"]');
    if (homeAnchor) {
      var drawer = document.querySelector('#Details-menu-drawer-container');
      if (drawer) drawer.removeAttribute('open');
      document.body.classList.remove('overflow-hidden-tablet');
    }
  });

  window.addEventListener('beforeprint', function () {
    document.querySelectorAll('.pp-home img, .pp-arrivals-grid img').forEach(function (img) {
      img.loading = 'eager';
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setDirections(false);
  });
})();
